import { FunctionComponent, useEffect } from "react";
import { FormikProps, useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import * as Yup from "yup";
import { updatePricing } from "../../Redux/Slicers/Pricing/UpdatePricingSlicer";
import { addPricing } from "../../Redux/Slicers/Pricing/AddPricingSlicer";
import TextInputField from "../../Components/TextInput/TextInputField";
import { Grid, Typography } from "@mui/material";
import TimePickers from "../../Components/TimePicker/TimePickers";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import ButtonField from "../../Components/Button/ButtonField";
import { IPricingList } from "./IPricing";
import Select from "../../Components/Select/Select";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { getSpaceTypes } from "../../Redux/Slicers/SpaceTypes/SpaceTypesSlicer";
interface MasterFormProps {
  TariffFrom: (data: FormikProps<any>) => void;
  rowId?: string | null; // 👈 new prop
  initialValues?: any;
}

const TariffForm: FunctionComponent<MasterFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { pathname } = location;
  const pathnameParts = location.pathname.split("/");
  const id = pathnameParts[pathnameParts.length - 1];
  const { updateableDate } = useAppSelector((state) => state.UpdatePricing);
  const { data: projectData } = useAppSelector((state) => state.SpaceTypes);
  useEffect(() => {
    console.log("useE", updateableDate);
    console.log("projectData", projectData);
    dispatch(getSpaceTypes(id));
  }, []);

  const idvalue = props.rowId;

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;

  // `space_type_id` coming from table row can be either a string id or a populated object.
  // Normalize it so the Select can match by `value`.
  const spaceTypeId = (() => {
    const st: any = (updateableDate as any)?.space_type_id;
    return typeof st === "string" ? st : st?._id || "";
  })();

  const initialValues = {
    name: updateableDate?.name || "",
    regularArea_HourlyRate: updateableDate?.hourlyRate || "",
    regularDayTimeCap: updateableDate?.dayTimeCap || "",
    regularNightTimeCap: updateableDate?.nightTimeCap || "",

    space_type_id: spaceTypeId,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    regularArea_HourlyRate: Yup.number()
      .required("Unit Rate is required")
      .positive("Unit Rate must be positive"),
    regularDayTimeCap: Yup.number()
      .required("Daytime Cap is required")
      .positive("Daytime Cap must be positive"),
    regularNightTimeCap: Yup.number()
      .required("Nighttime Cap is required")
      .positive("Nighttime Cap must be positive"),

    space_type_id: Yup.string().required("Please choose type"),
  });

  const data1 = projectData?.response?.data;
  console.log("data", data1, projectData);

  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.name,
        value: project._id!,
      }))
    : [];

  console.log("projects", projects);

  const tariffFrom = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(
          updatePricing({
            ...values,
            _id: idvalue,
            areaId: updateableDate._id,
            location_id: id,
            isUpdate: true,
          })
        );
      } else {
        dispatch(updatePricing({ ...values, _id: idvalue, location_id: id }));
      }
    },
  });

  return (
    <form
      className="master_form"
      onSubmit={tariffFrom.handleSubmit}
      onReset={tariffFrom.handleReset}
      autoComplete="off"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInputField
            id="name"
            name="name"
            label="Name"
            sx={{ width: "100%", marginBlock: "10px" }}
            value={tariffFrom.values.name}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={tariffFrom.touched.name && tariffFrom.errors.name}
            error={tariffFrom.touched.name && Boolean(tariffFrom.errors.name)}
          />
        </Grid>
        <Grid item xs={12}>
          <Select
            id="space_type_id"
            name="space_type_id"
            label="Space Type"
            value={projects?.find(
              (project: any) =>
                project.value === tariffFrom.values.space_type_id
            )}
            options={projects}
            onChange={(_, value) => {
              const projectValue = value as AutocompleteOption;
              tariffFrom.setFieldValue("space_type_id", projectValue?.value);
            }}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.space_type_id &&
              typeof tariffFrom.errors.space_type_id === "string"
                ? (tariffFrom.errors.space_type_id as string)
                : undefined
            }
            error={
              tariffFrom.touched.space_type_id &&
              Boolean(tariffFrom.errors.space_type_id)
            }
            placeholder="-select-"
          />
        </Grid>
        <Grid item xs={12} sx={{ display: "flex" }}>
          <Typography variant="caption">Area </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", columnGap: "10px" }}>
          <TextInputField
            id="regularArea_HourlyRate"
            name="regularArea_HourlyRate"
            label="Unit Rate"
            sx={{ width: "100%" }}
            type="number"
            className="margin-bottom"
            value={tariffFrom.values.regularArea_HourlyRate}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularArea_HourlyRate &&
              tariffFrom.errors.regularArea_HourlyRate
            }
            error={
              tariffFrom.touched.regularArea_HourlyRate &&
              Boolean(tariffFrom.errors.regularArea_HourlyRate)
            }
          />
          <TextInputField
            id="regularDayTimeCap"
            name="regularDayTimeCap"
            label="Daytime Cap"
            type="number"
            sx={{ width: "100%" }}
            className="margin-bottom"
            value={tariffFrom.values.regularDayTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularDayTimeCap &&
              tariffFrom.errors.regularDayTimeCap
            }
            error={
              tariffFrom.touched.regularDayTimeCap &&
              Boolean(tariffFrom.errors.regularDayTimeCap)
            }
          />
          <TextInputField
            id="regularNightTimeCap"
            name="regularNightTimeCap"
            label="Nighttime Cap"
            sx={{ width: "100%" }}
            type="number"
            value={tariffFrom.values.regularNightTimeCap}
            onChange={tariffFrom.handleChange}
            onBlur={tariffFrom.handleBlur}
            helperText={
              tariffFrom.touched.regularNightTimeCap &&
              tariffFrom.errors.regularNightTimeCap
            }
            error={
              tariffFrom.touched.regularNightTimeCap &&
              Boolean(tariffFrom.errors.regularNightTimeCap)
            }
          />
        </Grid>
      </Grid>

      <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
        <Grid item>
          <ButtonField
            type="submit"
            sx={{ minWidth: 120 }}
            className="add_button"
          >
            {updateableDate ? "Update" : "Save"}
          </ButtonField>
        </Grid>
      </Grid>
    </form>
  );
};

export default TariffForm;
